import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        permissions_manager: {
          tabs: {
            create: {
              tab_name: 'CREATE_TAB_NAME',
              role_name: 'CREATE_ROLE_NAME',
              copy_role: 'CREATE_COPY_ROLE',
              empty_role: 'CREATE_EMPTY_ROLE',
              add_role: 'CREATE_ADD_ROLE',
            },
            edit: {
              tab_name: 'EDIT_TAB_NAME',
              fields_settings_type: 'EDIT_FIELDS_SETTINGS_TYPE',
              choose_role: 'EDIT_CHOOSE_ROLE',
              sub_header_permissions: 'EDIT_SUB_HEADER_PERMISSIONS',
              sub_header_fields: 'EDIT_SUB_HEADER_FIELDS',
              columns_for_permit: {
                reports: 'report',
                creative_reports: 'creative_report',
                subaffiliate_reports: 'subaffiliate_report',
                affiliate_bookkeeping_months: 'list_affiliate_month_payments',
                affiliate_bookkeeping_one_month: 'list_affiliate_month_payments_in_one_month',
                dashboard_chart_by_day: 'chart_by_day',
                dashboard_chart_by_month: 'chart_by_month',
              },
            },
          },
          page_title: 'PAGE_TITLE',
          namespace: 'NAMESPACE',
        },
      },
    },
  }));
}
